export default {"src":"/_next/static/media/logo-bw.d485930d.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};